module.exports = __webpack_public_path__ + "img/result.fb75f0e8.png";